import { getSupportCenterDomain } from '@va/dashboard/selectors/customization';
import { SettingsHeading } from '@va/dashboard/ui/pages';
import { CalendarIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { contributorRole } from '@va/standalone/shared/selectors';
import { IconWithBackground, SelectDropdown } from '@va/ui/design-system';
import { useSelector } from 'react-redux';
import useFirstWeekDayCard, { getDropdownOptions } from './useFirstWeekDayCard';

export const FirstWeekDayCard = () => {
  const translate = useTranslate();

  const { onChange, selectedDay } = useFirstWeekDayCard();

  const isContributor = useSelector(contributorRole);
  const supportCenterDomain = useSelector(getSupportCenterDomain);

  return (
    <div className='flex flex-col gap-18px items-start'>
      <SettingsHeading
        title={translate('card.firstDayOfWeek.title')}
        subText={translate('card.firstDayOfWeek.subtitle')}
        tooltip={translate('card.firstDayOfWeek.tooltip', { supportCenterDomain })}
      />
      <div className='flex flex-col w-full gap-4'>
        <SelectDropdown
          icon={
            <IconWithBackground
              className='!bg-white'
              icon={() => <CalendarIcon color='#696969' className='w-4 h-4' />}
            />
          }
          disabled={isContributor}
          disabledTooltip={isContributor ? translate('tooltips.contributorRole') : undefined}
          label={translate('card.firstDayOfWeek.label')}
          onChange={onChange}
          selectedOption={selectedDay}
          dropdownOptions={getDropdownOptions(translate)}
          dropdownPlacement='bottom-start'
        />
      </div>
    </div>
  );
};
